import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE, API_URL } = environment;
@Injectable({
  providedIn: 'root'
})
export class SuperTransactionsService {

  constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

  //Get all super transactions
  getSuperTransactions(paramsObject : any) {
    var url = `${API_URLBLAZE}/transaction/super-transaction`;
    let params = new HttpParams(); 
    Object.keys(paramsObject).forEach(key => {
      params = params.set(key, paramsObject[key]);
    });
    return this.http.get(url, {params}).pipe(catchError(this.handleError()));
  }

  getSuperTransaction(id: string) {
    var url = `${API_URLBLAZE}/transaction/super-transaction/${id}`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  getTransactionByID(id: string) {
    var url = `${API_URLBLAZE}/transaction/super-transaction/transaction/${id}`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  getReasons() {
    var url = `${API_URLBLAZE}/transaction/super-transaction/reasons`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  saveSuperTransaction(request: any) {
    var url = `${API_URLBLAZE}/transaction/super-transaction`;
    return this.http.post(url, request).pipe(catchError(this.handleError()));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      if (error.status == 401) {
        this.storageService.clean()
        this.router.navigate(['/auth/login']);
      }
      result = error?.error;
      return of(result as T);
    };
  }
}
